import React from 'react';

import { toast } from 'ravenjs/lib/Toaster';

import CaseEditedToast from 'components/CaseEditedToast';
import { COLOR_TOKENS } from 'constants/quartz';

const CASE_EDITED_TOAST_DURATION = 10000;

const CASE_EDITED_TOAST_STYLE = {
    background: COLOR_TOKENS.feedback.info.background,
    color: COLOR_TOKENS.feedback.info.text,
    borderLeft: `4px solid ${COLOR_TOKENS.feedback.info.border}`,
};

export function showCaseEditedToast(editorName = 'Someone', field = 'details') {
    toast.info(
        <CaseEditedToast
            editorName={editorName || 'Someone'}
            field={field || 'details'}
            onReload={() => window.location.reload()}
        />,
        {
            autoClose: CASE_EDITED_TOAST_DURATION,
            style: CASE_EDITED_TOAST_STYLE,
            pauseOnHover: true,
        }
    );
}
